import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
export const CHECKOUT_URL = 'https://lumenakasha.impultienda.ar/checkout';
export const SUPPORT_EMAIL = 'soportelumenakasha@gmail.com';
export const WHATSAPP_LABEL = '11 5339-9780';
export const WHATSAPP_URL = 'https://wa.me/5491153399780';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
  glow?: boolean;
};
export function Section({
  children,
  className = '',
  id = '',
  glow = false
}: SectionProps) {
  const reduceMotion = useReducedMotion();
  return <motion.section id={id} initial={reduceMotion ? false : {
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.45,
    ease: [0.22, 1, 0.36, 1]
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-290" data-mp="fiks5r5le845">
      {glow && <div className="absolute inset-x-[12%] top-10 -z-10 h-48 rounded-full bg-brand-goldLight/50 blur-3xl" aria-hidden="true" data-id="element-291" data-mp="34l65sebqihc0" />}
      {children}
    </motion.section>;
}
type CTAButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  variant?: 'purple' | 'gold';
};
export function CTAButton({
  children,
  href = CHECKOUT_URL,
  className = '',
  fullWidth = false,
  variant = 'purple'
}: CTAButtonProps) {
  const reduceMotion = useReducedMotion();
  const colorClass = variant === 'purple' ? 'purple-gradient-bg' : 'gold-gradient-bg';
  return <motion.a href={href} whileHover={reduceMotion ? undefined : {
    scale: 1.02,
    y: -1
  }} whileTap={reduceMotion ? undefined : {
    scale: 0.98
  }} className={`cta-shimmer relative inline-flex items-center justify-center rounded-sm px-8 py-4 text-center text-base font-bold tracking-wide text-brand-paper shadow-[0_8px_20px_rgba(122,42,32,0.24)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-ink ${colorClass} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-292" data-mp="2cv1o4nfd08eh">
      <span className="relative z-10" data-id="element-293" data-mp="2by6i5h7k53o5">{children}</span>
    </motion.a>;
}
type SectionHeadingProps = {
  children: React.ReactNode;
  character?: string;
  className?: string;
};
export function SectionHeading({
  children,
  character = '氣',
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-294" data-mp="276y7khuhrc9e">
      <p className="font-kanji text-xl text-brand-goldDark/70 md:text-2xl" aria-hidden="true" data-id="element-295" data-mp="275n3si11q4ia">
        {character}
      </p>
      <h2 className="mt-2 font-serif text-2xl font-bold leading-tight text-brand-ink md:text-4xl" data-id="element-296" data-mp="2zoaj1gtd2pbg">
        {children}
      </h2>
      <span className="fret-rule mx-auto mt-4 block w-40 opacity-70 sm:w-56" aria-hidden="true" data-id="element-297" data-mp="o7h2961270hn" />
    </div>;
}